import * as m from "mithril";
import '../paymentselection/SelectedPaymentOption.scss';
import { MessageProvider } from "../../context/AppMessages";
import CustomSvgIcon from "../../components/CustomSvgIcon";

export default function PromoCodeApplyBox(): m.Component<{
    messageProvider: MessageProvider,
    appliedPromoCode: string | null,
    isInvalidPromoCode?: boolean,
    onAddPromoCode: (promoCode: string) => void,
    onRemovePromoCode: () => void
}> {
    let showPromoCodeApplyForm = false;

    let isSubmittingEmptyPromoCode = false;
    let errorMessage: string | null = null;

    let promoCodeValue: string = "";
    return {
        view(vnode) {
            let messageProvider = vnode.attrs.messageProvider;

            if (vnode.attrs.isInvalidPromoCode == true && vnode.attrs.appliedPromoCode != null && vnode.attrs.appliedPromoCode.trim() == promoCodeValue.trim() && promoCodeValue != "") {
                errorMessage = messageProvider.get("message.invalid_promo_code")
            } else if (isSubmittingEmptyPromoCode && promoCodeValue.trim() == "") {
                errorMessage = messageProvider.get("message.required_promo_code")
            } else {
                errorMessage = null;
            }

            function applyPromoCode() {
                if (promoCodeValue.trim() == "") {
                    isSubmittingEmptyPromoCode = true;
                } else {
                    vnode.attrs.onAddPromoCode(promoCodeValue);
                }
            }

            return [
                showPromoCodeApplyForm ?
                    m("div.bg-light p-3",
                        m("div.promo-content-container clickable-area",
                            m("div. color-light-blue remove-promo-content", {
                                onclick: (event) => {
                                    event.preventDefault();
                                    showPromoCodeApplyForm = false;
                                    errorMessage = null;
                                    promoCodeValue = "";
                                    isSubmittingEmptyPromoCode = false;
                                    vnode.attrs.onRemovePromoCode()
                                }
                            },
                                m(CustomSvgIcon, {
                                    iconType: "cross_remove_fill",
                                    themeCssClass: "svg-muted svg-small"
                                })
                            )
                        ),
                        m("div", { class: "input-group" }, [
                            m("input", {
                                "class": "form-control",
                                oncreate: (vnode) => {
                                    (vnode.dom as HTMLInputElement).focus();
                                },
                                "placeholder": messageProvider.get("promo_code"),
                                value: promoCodeValue,
                                oninput: (event) => {
                                    event.preventDefault();
                                    if (event.target.value != null) {
                                        promoCodeValue = event.target.value
                                    }
                                },
                                onkeyup: (event) => {
                                    if (event.key === "Enter") {
                                        applyPromoCode();
                                    }
                                }
                            }),
                            m("div.input-group-append",
                                m("button", {
                                    "class": "btn btn-outline-success",
                                    "type": "button",
                                    onclick: (event) => {
                                        event.preventDefault();
                                        applyPromoCode();
                                    }
                                }, messageProvider.get("apply_code"))
                            )
                        ]),
                        errorMessage != null ? m("small.ms-2 ml-2 mt-2 text-danger", errorMessage) : null
                    )
                    :
                    m("div.", {
                        class: "bg-light p-2 clickable-area",
                        onclick: (event) => {
                            event.preventDefault();
                            showPromoCodeApplyForm = true;
                        }
                    },
                        m("div.d-flex justify-content-end align-items-center text-success",

                            m(CustomSvgIcon, {
                                iconType: "tag_fill",
                                themeCssClass: "svg-mint-green svg-small"
                            }),
                            m("small.ms-1 ml-1", messageProvider.get("apply_promo_code")),
                        ),
                    )
            ]
        },
    }
}